<template>
  <div class="box">
    <p class="title is-5">{{ $t("dashboard.web.most_visited_pages") }}</p>
    <div style="overflow-y: scroll; height: 380px">
      <b-table :data="pages.data" :loading="pages.loading">
        <template slot-scope="{ row: page }">
          <b-table-column width="600" label="Page">
            <div>{{ page.pageTitle }}</div>
            <a :href="page.url" target="_blank">
              <small>{{ page.url }}</small>
            </a>
          </b-table-column>

          <b-table-column label="Views" centered>
            {{ page.pageViews }}
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pages: new window.RemoteCollection(
        "/admin/api/web/analytics/most-visited-pages"
      ),
    };
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    },
  },

  methods: {
    load() {
      this.pages.with({ date_range: this.$route.query.date_range }).load();
    },
  },
};
</script>
